/* M'OUD v14 «Maison überall» (23.10.2026). Schrift, Einblenden, Rauch, Nummer, Bildstreifen. Ohne Bibliotheken. */
(function () {
  var d = document, w = window, b = d.body;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var roots = [].slice.call(d.querySelectorAll('.m14'));
  if (!roots.length) return;

  /* Schrift zeilenweise aufziehen */
  d.querySelectorAll('.m14 [data-split]').forEach(function (el) {
    var parts = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = parts.map(function (p, i) { return '<span class="ln"><span style="transition-delay:' + (0.2 + i * 0.12) + 's">' + p + '</span></span>'; }).join('');
  });
  requestAnimationFrame(function () { setTimeout(function () { roots.forEach(function (r) { r.classList.add('go'); }); }, 100); });

  /* Einblenden */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .16 });
  d.querySelectorAll('.m14 [data-rv], .m14-ing li, .m14-pyr div, .m14-strip figure, .m14-more a, .m14-co__tx > *, .m14-mo__tx > *, .m14-nr__tx > *, .m14-set__in > div > *, .m14-days .m14-vials').forEach(function (el, i) {
    el.classList.add('rv'); el.style.transitionDelay = ((i % 4) * 0.08) + 's'; io.observe(el);
  });
  d.querySelectorAll('.m14-days, .m14-raw__img').forEach(function (el) { io.observe(el); });
  /* Seiten: die Inhalte unter dem Kopf ruhig einblenden */
  if (b.classList.contains('m14pg')) {
    d.querySelectorAll('.m14-head ~ .wrap > *, .m14-head ~ .wrap .www > div, .m14-head ~ .wrap .list a').forEach(function (el, i) {
      if (el.classList.contains('reveal')) return; el.classList.add('rv'); el.style.transitionDelay = ((i % 3) * 0.07) + 's'; io.observe(el);
    });
  }

  /* Nummer zählt hoch */
  d.querySelectorAll('.m14 [data-count]').forEach(function (cnt) {
    new IntersectionObserver(function (es, o) {
      if (!es[0].isIntersecting) return; o.disconnect();
      var to = +cnt.getAttribute('data-count'), st = performance.now(), dur = reduce ? 1 : 2000;
      (function tick(n) { var k = Math.min(1, (n - st) / dur); k = 1 - Math.pow(1 - k, 3); cnt.textContent = Math.max(1, Math.round(k * to)); if (k < 1) requestAnimationFrame(tick); })(st);
    }, { threshold: .5 }).observe(cnt);
  });

  /* Bilder gleiten beim Scrollen leicht (Moment, Düfte) */
  var par = [].slice.call(d.querySelectorAll('.m14-mo__img img, .m14-co__img img'));
  if (par.length && !reduce) {
    var tk = false;
    var run = function () {
      tk = false; var vh = w.innerHeight;
      par.forEach(function (img) { var r = img.parentNode.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; var p = (r.top + r.height / 2 - vh / 2) / vh; img.style.setProperty('--py', (p * -40).toFixed(1) + 'px'); });
    };
    w.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(run); } }, { passive: true }); run();
  }

  /* Bildstreifen: ziehen mit der Maus, Pfeile */
  d.querySelectorAll('.m14-strip').forEach(function (s) {
    var down = false, sx = 0, sl = 0, moved = false;
    s.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = s.scrollLeft; s.classList.add('drag'); });
    w.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 3) moved = true; s.scrollLeft = sl - dx; });
    w.addEventListener('pointerup', function () { if (!down) return; down = false; s.classList.remove('drag'); });
    var sec = s.closest('section'); if (!sec) return;
    sec.querySelectorAll('[data-strip]').forEach(function (bt) {
      bt.addEventListener('click', function () { var f = s.querySelector('figure'); var step = f ? f.getBoundingClientRect().width + 20 : 400; s.scrollBy({ left: (+bt.getAttribute('data-strip')) * step, behavior: 'smooth' }); });
    });
  });

  /* Rauch über dem Oud-Amal-Bild (WebGL, warmes Gold, folgt sanft der Hand) */
  d.querySelectorAll('.m14-smoke').forEach(function (c) {
    if (reduce) return;
    var gl = c.getContext('webgl', { premultipliedAlpha: false, antialias: false }); if (!gl) return;
    var vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    var fs = 'precision mediump float;uniform vec2 r;uniform float t;uniform vec2 m;' +
      'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}' +
      'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}' +
      'float fb(vec2 p){float v=0.,a=.5;for(int i=0;i<6;i++){v+=a*n(p);p=p*2.02+vec2(1.7,9.2);a*=.5;}return v;}' +
      'void main(){vec2 uv=gl_FragCoord.xy/r;vec2 q=uv*vec2(r.x/r.y,1.)*2.2;float tt=t*.045;' +
      'vec2 mm=(m-uv)*vec2(r.x/r.y,1.);float md=exp(-dot(mm,mm)*6.);' +
      'q+=vec2(0.,-tt*3.);vec2 w=vec2(fb(q+tt),fb(q+vec2(5.2,1.3)-tt));' +
      'float f=fb(q+2.4*w+md*1.2);float rise=smoothstep(0.,.85,1.-uv.y)*.75+.25;' +
      'float a=smoothstep(.5,.95,f)*rise*(.5+md*.9);vec3 col=mix(vec3(.55,.42,.27),vec3(.98,.86,.62),f);' +
      'gl_FragColor=vec4(col*a*.5,1.);}';
    function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; }
    var pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
    gl.useProgram(pr);
    var bf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, bf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var ur = gl.getUniformLocation(pr, 'r'), ut = gl.getUniformLocation(pr, 't'), um = gl.getUniformLocation(pr, 'm');
    var mx = .5, my = .4, tx = .5, ty = .4, vis = true, t0 = performance.now();
    function size() { var k = Math.min(w.devicePixelRatio || 1, 1.5) * .5; c.width = Math.max(1, Math.round(c.clientWidth * k)); c.height = Math.max(1, Math.round(c.clientHeight * k)); gl.viewport(0, 0, c.width, c.height); }
    size(); w.addEventListener('resize', size);
    c.parentNode.addEventListener('pointermove', function (e) { var r = c.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width; ty = 1 - (e.clientY - r.top) / r.height; });
    new IntersectionObserver(function (es) { var was = vis; vis = es[0].isIntersecting; if (vis && !was) requestAnimationFrame(loop); }).observe(c);
    function loop(now) {
      if (!vis) return;
      mx += (tx - mx) * .04; my += (ty - my) * .04;
      gl.uniform2f(ur, c.width, c.height); gl.uniform1f(ut, (now - t0) / 1000); gl.uniform2f(um, mx, my);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4); requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  });

  /* Weiter-Pfeil im Held */
  d.querySelectorAll('[data-m14go]').forEach(function (a) {
    a.addEventListener('click', function (e) { var t = d.querySelector(a.getAttribute('href')); if (!t) return; e.preventDefault(); w.scrollTo({ top: t.getBoundingClientRect().top + w.scrollY - 60, behavior: reduce ? 'auto' : 'smooth' }); });
  });
})();
